export default "__VITE_ASSET__8808384b__"